/**
 * 卖家须知弹窗(发布守卫链第 4 层)。design 无此 modal —— 用 _shared C-5 对话框构件承载。
 * 勾选「继续发布」→ accept → 续写提交;关闭 → 丢弃 pendingAction 不发布(语义同 App)。
 */
import { useEffect, useState } from 'react';
import { Dialog } from '@/components/ui/Dialog';

export function SellerNoticeDialog({
  open,
  currentVersion,
  submitting,
  onAccept,
  onClose,
}: {
  open: boolean;
  currentVersion?: string;
  submitting: boolean;
  onAccept: () => void;
  onClose: () => void;
}) {
  const [checked, setChecked] = useState(false);

  // 每次打开重置勾选:取消后再进(可能是新版本须知)需重新明确同意,不沿用旧勾选。
  useEffect(() => {
    if (open) setChecked(false);
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} labelledBy="seller-notice-title">
      <h3 id="seller-notice-title">卖家须知</h3>
      <div className="sm muted" style={{ maxHeight: 280, overflowY: 'auto', lineHeight: 1.8 }}>
        <p>发布商品前,请阅读并遵守以下卖家须知:</p>
        <ul style={{ paddingLeft: '1.1em' }}>
          <li>如实描述所提供的商品内容、交付方式与边界,不得虚假宣传。</li>
          <li>不得发布违法违规、涉黄涉赌、诱导站外交易或引流的内容。</li>
          <li>按约定履约,保障买家权益;平台按规则对违规行为降权或封禁。</li>
          <li>成交后平台按规则抽取服务费,收益经结算后可提现。</li>
        </ul>
        {currentVersion && <p className="xs muted">须知版本:{currentVersion}</p>}
      </div>

      <label className="row gap-2 mt-4" style={{ alignItems: 'flex-start', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          style={{ marginTop: 4 }}
        />
        <span className="sm">我已阅读并同意《卖家须知》</span>
      </label>

      <div className="row gap-4 mt-6" style={{ justifyContent: 'flex-end' }}>
        <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
          取消
        </button>
        <button
          type="button"
          className="btn btn-primary"
          disabled={!checked || submitting}
          onClick={onAccept}
        >
          {submitting ? '提交中…' : '继续发布'}
        </button>
      </div>
    </Dialog>
  );
}
